class SizeGuideArrows extends HTMLElement {
  constructor() {
    super();

    this.container = document.querySelector('.size-guide__details');
    this.leftButton = this.querySelector('.size-guide--scroll-left');
    this.rightButton = this.querySelector('.size-guide--scroll-right');

    this.bindEvents();
  }

  bindEvents() {
    this.leftButton.addEventListener('click', () => this.scrollToStart());
    this.rightButton.addEventListener('click', () => this.scrollToEnd());
    this.container.addEventListener('scroll', () => this.updateButtonsVisibility());
    this.updateButtonsVisibility();
  }

  scrollToStart() {
    this.container.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  }

  scrollToEnd() {
    this.container.scrollTo({
      left: this.container.scrollWidth - this.container.clientWidth,
      behavior: 'smooth'
    });
  }

  updateButtonsVisibility() {
    const isAtStart = this.container.scrollLeft === 0;
    const isAtEnd = this.container.scrollLeft >= (this.container.scrollWidth - this.container.clientWidth - 1);

    this.leftButton.style.opacity = isAtStart ? '0.5' : '1';
    this.rightButton.style.opacity = isAtEnd ? '0.5' : '1';

    this.leftButton.classList.toggle('disabled', isAtStart);
    this.rightButton.classList.toggle('disabled', isAtEnd);
  }
}

if (!customElements.get('size-guide-arrows')) {
  customElements.define('size-guide-arrows', SizeGuideArrows);
}